module.exports = __webpack_public_path__ + "static/media/opponentsturn.f76ff9d8.png";